import Axios from "axios";
import handleAjaxError from "../helpers/handleAjaxError";

let notification = null;

/**
 * This setups the draggable window which shows the
 * current logged in user and logout/admin panel links
 */
function initLoginAsUser(){
	notification = document.querySelector('.logged-in-as-user-notification');
	if(notification){
		const logoutLink = notification.querySelector('.logout-link');
		logoutLink.onclick = (e) => {
			e.preventDefault();
			console.log(logoutLink.href);
			Axios.get(logoutLink.href)
				.then(() => {
					loading();

					// Remove query parameter requesting impersonation if exists
					window.location.href = window.location.href.replace(/_as=\d+/,'');
				})
				.catch(handleAjaxError);
		}

		notification.addEventListener('mousedown', startDragging)
		notification.addEventListener('touchstart', startDragging)

		// Need to setup initial style values
		notification.style.top = `16px`;
		notification.style.right = `16px`;
	}
}


function startDragging() {
	document.addEventListener('mousemove', dragNotification)
	document.addEventListener("touchmove", dragNotification, {
		passive: false
	});
	document.addEventListener('mouseup', stopDragging)
	document.addEventListener('touchend', stopDragging)
}
let previousTouch = null;

function dragNotification(e) {
	e.preventDefault();

	let top = parseFloat(notification.style.top.split('px')[0]);
	let right = parseFloat(notification.style.right.split('px')[0]);

	let movementX = e.movementX;
	let movementY = e.movementY;

	if (e.touches) {
		const touch = e.touches[0];

		if (previousTouch) {
			movementX = touch.pageX - previousTouch.pageX;
			movementY = touch.pageY - previousTouch.pageY;

		}

		previousTouch = touch;
	}

	window._dragging = true;

	top = top + movementY;
	right = right - movementX;

	if (top >= window.innerHeight - 50) {
		top = window.innerHeight - 50;
	}
	if (top <= 5) {
		top = 5;
	}

	if (right >= window.innerWidth - 200) {
		right = window.innerWidth - 200;
	}
	if (right <= 5) {
		right = 5;
	}


	notification.style.top = `${top}px`;
	notification.style.right = `${right}px`;
	console.log(notification);
}

function stopDragging() {
	document.removeEventListener('mousemove', dragNotification);
	document.removeEventListener('touchmove', dragNotification);
	previousTouch = null;
	setTimeout(() => {
		window._dragging = false;
	}, 50)
}

export {initLoginAsUser}
